import {useState} from "react";
import {Alert, AlertTitle} from "@/primitives/Alert";
import {Button} from "@/primitives/Button";
import {FA6Icon} from "@/primitives/FA6Icon";
import {api} from "@/shared/api";
import {CalendarLinkRow} from "@/components/calendarLinkRow";
import {CalendarLinkActions} from "@/components/calendarLinkActions";

/* The ICS links are served from the page's own origin, not the client-specific timrBaseUrl. */
function calendarUrl(fileName: string): string {
	return new URL(`/timr/cal/${fileName}`, window.location.href).href;
}

export function CalendarPanel({calendarSubscriptionToken: token}: {calendarSubscriptionToken: string | null}) {
	const [busy, setBusy] = useState(false);

	/* The generate endpoint returns no token, so a reload fetches the new links — as before. */
	const generate = () => {
		setBusy(true);
		api("generateCalendarSubscriptionToken.json")
			.post()
			.done(() => location.reload())
			.fail(() => setBusy(false));
	};

	const remove = () => {
		setBusy(true);
		api("removeCalendarSubscriptionToken.json")
			.post()
			.done(() => location.reload())
			.fail(() => setBusy(false));
	};

	return (
		<div className="panel panel-flat">
			<div className="panel-heading">
				<h5 className="panel-title">{messages["user.settings.calendar"]}</h5>
			</div>
			<div className="panel-body form-horizontal">
				{token == null ? (
					<>
						<p className="content-group">
							{messages["user.settings.calendar.privateUrl.info"]}
						</p>
						<div className="text-right">
							<Button onClick={generate} disabled={busy}>
								<FA6Icon icon="link" variant="regular" fixedWidth className="mr-5"/>
								{messages["user.settings.calendar.privateUrl.generate"]}
							</Button>
						</div>
					</>
				) : (
					<>
						<p className="content-group">{messages["user.settings.calendar.desc"]}</p>
						<Alert variant="danger" iconPosition="left">
							<AlertTitle>{messages["dialog.warning.title"]}</AlertTitle>
							{messages["user.settings.calendar.privateUrl.warning"]}
						</Alert>
						{globals.workingTimeEnabled && (
							<CalendarLinkRow
								label={messages["user.settings.calendar.workingTime"]}
								url={calendarUrl(`workingtime-${token}.ics`)}
							/>
						)}
						{globals.projectTimeEnabled && (
							<CalendarLinkRow
								label={messages["user.settings.calendar.projectTime"]}
								url={calendarUrl(`projecttime-${token}.ics`)}
							/>
						)}
						{globals.driveLogEnabled && (
							<CalendarLinkRow
								label={messages["user.settings.calendar.drivelog"]}
								url={calendarUrl(`drivelog-${token}.ics`)}
							/>
						)}
						<CalendarLinkActions
							calendarName={messages["user.settings.calendar"]}
							busy={busy}
							onRenew={generate}
							onDeactivate={remove}
						/>
					</>
				)}
			</div>
		</div>
	);
}
